<template>
  <v-toolbar dark :class="toolbarColor">
    <v-toolbar-title class="white--text">
      {{ title }}
    </v-toolbar-title>
    <v-spacer />
    <v-divider
      class="mx-4"
      inset
      vertical
    />
    <v-tooltip
        v-for="button in buttons"
        :key="button.id"
        top
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :name="button.name"
          :color="button.color"
          :disabled="disabled"
          :loading="loading"
          fab
          small
          class="mx-2"
          v-on="on"
          @click="emitEvent(button.event, $event)"
        >
          <v-icon :name="button.name" >
            {{ button.icon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ button.name }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
      title: {
        type: String,
        required: true,
        default: 'Titulo',
      },
      buttons: {
        type: Array,
        required: true,
      },
      loading: { default: false },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  computed: {
    ...mapGetters({
      toolbarColor: 'theme/toolbarColor',
    }),
  },
  methods: {
    emitEvent(event, mouseEvent) {
      this.$emit(event, mouseEvent.target.name);
    },
  },
};
</script>
